import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventOnboardingDecision } from '@onefootprint/request-types/dashboard';
import { ActorKind } from '@onefootprint/types';
import AnnotationNote from '../annotation-note';
type OnboardingDecisionEventBodyProps = {
  data: UserTimelineEventOnboardingDecision['data'];
};
const OnboardingDecisionEventBody = t0 => {
  const $ = _c(2);
  const {
    data
  } = t0;
  const {
    annotation,
    decision: t1
  } = data;
  const {
    source
  } = t1;
  if (annotation && source.kind !== ActorKind.footprint) {
    let t2;
    if ($[0] !== annotation) {
      t2 = <AnnotationNote annotation={annotation} />;
      $[0] = annotation;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  return null;
};
export default OnboardingDecisionEventBody;